export const setLsItem = (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value))
}
export const getLsItem = (key: string) => {
  return  JSON.stringify(localStorage.getItem(key))
}
export const clearLs = () => {
  localStorage.clear()
}